import React from 'react'; 

const AssessmentHeader = ({children, className}) => (
	<div className={'assessment-header' + (className ? ' ' + className : '')}>
		<span className="header-text">{children}</span>
	</div>
);

export default AssessmentHeader;
